// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as moment from 'moment'
Vue.prototype.$moment = moment;
Vue.use(ElementUI)
Vue.config.productionTip = false

// 路由拦截
router.beforeEach((to, from, next) => {

  document.title = to.meta.title || '';
  const user = sessionStorage.getItem('token');
  if (!user && to.path !== '/login') {
    next('/login');
  } else if (user && to.path == '/login') {
    next('/home')
  } else {
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js